import Vue from 'vue';
import Router from 'vue-router';
import CabinetList from '@/components/cabinetList/CabinetList';
import CabinetDetail from '@/components/cabinetDetail/CabinetDetail';
import CabinetDynamicDetail from '@/components/cabinetDetail/DynamicDetail';
import IpAddress from '@/components/ipAddress/IpAddress';
import BandWidth from '@/components/bandWidth/BandWidth';
import BandWidthDetail from '@/components/bandWidthDetail/BandWidthDetail';
import EquipmentList from '@/components/Equipment/EquipmentList';
import EquipmentDetail from '@/components/Equipment/EquipmentDetail';
import BuyCabinet from '@/components/buyCabinet/BuyCabinet';

// 工单管理 => 提交工单
import SubmitWorkSheet from '@/components/workSheet/SubmitWorkSheet';
import CabinetOutfit from '@/components/workSheet/CabinetOutfit';
// 工单管理 => 我的工单
import MyWorksheet from '@/components/workSheet/MyWorksheet';
// 工单管理 => 我的工单 => 工单详情
import WorksheetDetail from '@/components/workSheet/WorksheetDetail';

// 概览
import OverView from '@/components/resourceOverview/OverView';
import HomeOverView from '@/components/resourceOverview/HomeOverView';
import BandwidthTraffic from '@/components/bandwidthTraffic/TrafficList';
import BandwidthTrafficDetail from '@/components/bandwidthTraffic/TrafficDetail';

// 机房
import DataCenterList from '@/components/idcs/IdcsList';
// 专线
import DirectConnectsList from '@/components/directConnects/DirectConnectsList';
// 其他资源
import OtherResourceList from '@/components/otherResource/OtherResourceList';
import NoticeList from '@/components/notice/List';
import NoticeDetail from '@/components/notice/Detail';
// 封网和割接通知（复用公告列表/详情组件，通过 noticeType query 区分）
import NetworkFreezeCutoverList from '@/components/notice/List';
import NetworkFreezeCutoverDetail from '@/components/notice/Detail';

// 账单
import BillList from "@/components/billList/BillList";
// 巡检报告
import InspectionRegionList from "@/components/inspection/region/RegionList";
import InspectionDeviceList from "@/components/inspection/device/DeviceList";


Vue.use(Router);

// permission1 字段说明：
// 对应后端 /api/consumer/getConsoleMenuPermission 接口返回的 menuConfigs key
// 1 表示有权限，0 表示无权限
// 注意：当某个左侧菜单无权限时，其子路由（详情页等）也无权限
// 例如：cabinet 无权限时，"/cabinet/detail"、"/cabinet/dynamic" 也是无权限
export default new Router({
  mode: "history",
  routes: [
    {
      // 不匹配的路由，跳回首页（当前没有404页）
      path: "*",
      redirect: "/",
      meta: {
        permission: "",
        permission1: ""
      }
    },
    {
      path: "/",
      name: "Default",
      meta: {
        permission: "",
        permission1: ""
      },
      component: OverView
    },
    {
      path: "/resourcemanagement/overview",
      name: "homeOverView",
      meta: {
        permission: "",
        // 概览菜单
        permission1: "overView",
        title: "概览"
      },
      component: HomeOverView
    },
    {
      path: "/ipAddress/list",
      name: "IpAddress",
      meta: {
        permission: "resource",
        // IP 菜单
        permission1: "ip",
        title: "公网IP"
      },
      component: IpAddress
    },
    // 资源管理 - 带宽
    {
      path: "/bandWidth/list",
      name: "BandWidth",
      meta: {
        permission: "resource",
        // 带宽菜单
        permission1: "bandwidth",
        title: "带宽(出口)"
      },
      component: BandWidth
    },
    // 资源管理 - 机房
    {
      path: "/idcDataCenter/list",
      name: "IdcDataCenter",
      meta: {
        permission: "resource",
        // 机房菜单
        permission1: "idc",
        title: "机房"
      },
      component: DataCenterList
    },
    // 资源管理 - 机柜
    {
      path: "/cabinet/list",
      name: "CabinetList",
      meta: {
        permission: "resource",
        // 机柜菜单
        permission1: "cabinet",
        title: "机柜"
      },
      component: CabinetList
    },
    // 资源管理 - 专线
    {
      path: "/directConnects/list",
      name: "DirectConnectsList",
      meta: {
        permission: "resource",
        // 专线菜单
        permission1: "directConnect",
        title: "专线"
      },
      component: DirectConnectsList
    },
    // 资源管理 - 其他资源
    {
      path: "/otherResource/list",
      name: "OtherResourceList",
      meta: {
        permission: "resource",
        // 其他资源菜单
        permission1: "otherResource",
        title: "其他资源"
      },
      component: OtherResourceList
    },
    // 概览 - 公告列表（属于概览菜单下子页面）
    {
      path: "/notice/list",
      name: "NoticeList",
      meta: {
        permission: "alarm",
        // 公告归属概览菜单
        permission1: "overView",
        title: "公告列表"
      },
      component: NoticeList
    },
    // 概览 - 公告详情
    {
      path: "/notice/detail",
      name: "NoticeDetail",
      meta: {
        permission: "alarm",
        // 公告详情归属概览菜单
        permission1: "overView",
        title: "公告详情"
      },
      component: NoticeDetail
    },
    // 封网和割接通知 - 列表（复用 NoticeList 组件，通过 query.noticeType 区分）
    {
      path: "/networkFreezeCutover/list",
      name: "NetworkFreezeCutoverList",
      meta: {
        permission: "alarm",
      },
      component: NetworkFreezeCutoverList
    },
    // 封网和割接通知 - 详情（复用 NoticeDetail 组件，通过 query.noticeType 区分）
    {
      path: "/networkFreezeCutover/detail",
      name: "NetworkFreezeCutoverDetail",
      meta: {
        permission: "alarm",
      },
      component: NetworkFreezeCutoverDetail
    },
    {
      path: "/cabinet/detail",
      name: "CabinetDetail",
      meta: {
        permission: "resource",
        // 机柜详情属于机柜菜单
        permission1: "cabinet",
        title: "机柜详情"
      },
      component: CabinetDetail
    },
    {
      path: "/cabinet/dynamic",
      name: "CabinetDynamicDetail",
      meta: {
        permission: "resource",
        // 机柜动环属于机柜菜单
        permission1: "cabinet",
        title: "机柜动环详情"
      },
      component: CabinetDynamicDetail
    },
    {
      path: "/equipment/list",
      name: "EquipmentList",
      meta: {
        permission: "resource",
        // 设备菜单
        permission1: "device",
        title: "设备列表"
      },
      component: EquipmentList
    },
    {
      path: "/equipment/detail",
      name: "EquipmentDetail",
      meta: {
        permission: "resource",
        // 设备详情属于设备菜单
        permission1: "device",
        title: "设备详情"
      },
      component: EquipmentDetail
    },
    {
      path: "/worksheet/init",
      name: "SubmitWorkSheet",
      meta: {
        permission: "ticket",
        // 提交工单菜单
        permission1: "submitTicket",
        title: "提交工单"
      },
      component: SubmitWorkSheet
    },
    {
      path: "/worksheet/submit/:id",
      name: "CabinetOutfit",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "提交工单详情"
      },
      component: CabinetOutfit
    },
    {
      path: "/myworksheet/list",
      name: "MyWorksheet",
      meta: {
        permission: "ticket",
        // 我的工单菜单
        permission1: "myTicket",
        title: "我的工单"
      },
      component: MyWorksheet
    },
    {
      path: "/myworksheet/detail/:id",
      name: "WorksheetDetail",
      meta: {
        permission: "ticket",
        // 工单详情属于我的工单菜单
        permission1: "myTicket",
        title: "工单详情"
      },
      component: WorksheetDetail
    },
    {
      path: "/bandwidth/detail",
      name: "BandWidthDetail",
      meta: {
        permission: "resource",
        // 带宽详情属于带宽菜单
        permission1: "bandwidth",
        title: "带宽详情"
      },
      component: BandWidthDetail
    },
    // 资源监控 - 带宽流量
    {
      path: "/bandwidthtraffic/list",
      name: "BandwidthTraffic",
      meta: {
        permission: "monitor",
        // 带宽流量菜单
        permission1: "bandwidthTraffic",
        title: "带宽流量"
      },
      component: BandwidthTraffic
    },
    {
      path: "/bandwidthtraffic/detail/:id",
      name: "BandwidthTrafficDetail",
      meta: {
        permission: "monitor",
        // 带宽流量详情属于带宽流量菜单
        permission1: "bandwidthTraffic",
        title: "带宽流量详情"
      },
      component: BandwidthTrafficDetail
    },
    {
      path: "/worksheet/submit/equipmentMoveIn/:id/:code",
      name: "EquipmentIn",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "设备迁入提交工单"
      },
      component: () => import("@/components/workSheet/equipmentIn/EquipmentIn")
    },
    {
      path: "/worksheet/submit/equipmentMoveOut/:id/:code",
      name: "EquipmentOut",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "设备迁出提交工单"
      },
      component: () =>
        import("@/components/workSheet/equipmentOut/EquipmentOut")
    },
    {
      path: "/worksheet/submit/equipmentMove/:id/:code",
      name: "EquipmentMove",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "设备迁移提交工单"
      },
      component: () =>
        import("@/components/workSheet/equipmentMove/EquipmentMove")
    },
    {
      path: "/generalServer/:id/:code",
      name: "GeneralServices",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "通用服务"
      },
      component: () =>
        import("@/components/workSheet/generalServer/GeneralServices")
    },
    {
      path: "/worksheet/submit/roomEntry/:id",
      name: "RoomEntry",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "机房入驻"
      },
      component: () => import("@/components/workSheet/roomEntry/RoomEntry")
    },
    {
      path: "/worksheet/submit/servicesupport/:ticketTypeId/:ticketTemplateId",
      name: "ServiceSupport",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "服务申请"
      },
      component: () =>
        import("@/components/workSheet/serviceSupport/ServiceSupport")
    },
    {
      path: "/worksheet/submit/faultReport/:ticketTemplateId/:ticketTypeId",
      name: "FaultReport",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "故障报障"
      },
      component: () => import("@/components/workSheet/faultReport/FaultReport")
    },
    {
      path: "/worksheet/submit/collectDelivery/:ticketTemplateId/:ticketTypeId",
      name: "collectDelivery",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "快递收货"
      },
      component: () => import("@/components/workSheet/expressDelivery/receive")
    },
    {
      path: "/worksheet/submit/SendDelivery/:ticketTemplateId/:ticketTypeId",
      name: "SendDelivery",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "快递寄件"
      },
      component: () => import("@/components/workSheet/expressDelivery/send")
    },
    {
      path: "/alarmrules/list",
      name: "AlarmRulesList",
      meta: {
        permission: "alarm",
        // 告警规则菜单
        permission1: "alarmRule",
        title: "告警规则列表"
      },
      component: () => import("@/components/alarm/rules/RulesList")
    },
    {
      path: "/alarmrules/new",
      name: "AlarmRulesAdd",
      meta: {
        permission: "alarm",
        permission1: "alarmRule",
        title: "新建告警规则"
      },
      component: () => import("@/components/alarm/rules/RulesAdd")
    },
    {
      path: "/alarmrules/edit/:id",
      name: "AlarmRulesEdit",
      meta: {
        permission: "alarm",
        permission1: "alarmRule",
        title: "编辑告警规则"
      },
      component: () => import("@/components/alarm/rules/RulesAdd")
    },
    {
      path: "/alarmrules/detail/:id",
      name: "AlarmRulesDetail",
      meta: {
        permission: "alarm",
        permission1: "alarmRule",
        title: "告警规则详情"
      },
      component: () => import("@/components/alarm/rules/RulesDetail")
    },
    {
      path: "/alarmhistory/list",
      name: "AlarmHistoryList",
      meta: {
        permission: "alarm",
        // 告警历史菜单
        permission1: "alarmHistory",
        title: "告警历史列表"
      },
      component: () => import("@/components/alarm/history/AlarmHistory")
    },
    {
      path: "/worksheet/submit/cabinetPowerUp/:ticketTypeId/:ticketTemplateId",
      name: "cabinetPowerUp",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "上电"
      },
      component: () =>
        import("@/components/workSheet/cabinet-powerUp/cabinetPowerUp")
    },
    {
      path:
        "/worksheet/submit/cabinetReservation/:ticketTypeId/:ticketTemplateId",
      name: "cabinetReservation",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "机柜预约"
      },
      component: () =>
        import("@/components/workSheet/cabinet-reservation/cabinetReservation")
    },
    // { // 删除零售投放的购买机柜页面
    //   path: "/aidc/create",
    //   name: "buyCabinet",
    //   meta: {
    //     permission: "",
    //     // 购买机柜页不做菜单权限校验
    //     permission1: ""
    //   },
    //   component: () => import("@/components/buyCabinet/BuyCabinet")
    // },
    {
      path: "/worksheet/submit/cabinetPowerOff/:ticketTypeId/:ticketTemplateId",
      name: "cabinetPowerOff",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "下电"
      },
      component: () =>
        import("@/components/workSheet/cabinet-powerOff/cabinetPowerOff")
    },
    {
      path:
        "/worksheet/submit/equipmentUnsubscribe/:ticketTypeId/:ticketTemplateId",
      name: "equipmentUnsubscribe",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "设备退订"
      },
      component: () =>
        import(
          "@/components/workSheet/equipment-unsubscribe/equipmentUnsubscribe"
        )
    },
    {
      path: "/worksheet/submit/deviceOpen/:ticketTypeId/:ticketTemplateId",
      name: "deviceOpen",
      meta: {
        permission: "ticket",
        permission1: "submitTicket",
        title: "开通端口"
      },
      component: () => import("@/components/workSheet/device-open/deviceOpen")
    },
    {
      path: "/bill/list",
      name: "BillList",
      meta: {
        permission: "consumption",
        // 账单页面不在新菜单权限配置中，留空跳过校验
        permission1: ""
      },
      component: BillList
    },
    {
      path: "/inspectionRegion/list",
      name: "InspectionRegionList",
      meta: {
        permission: "inspection",
        // 机房巡检菜单
        permission1: "inspectIdc",
        title: "机房巡检列表"
      },
      component: InspectionRegionList
    },
    {
      path: "/inspectionDevice/list",
      name: "InspectionDeviceList",
      meta: {
        permission: "inspection",
        // 设备巡检菜单
        permission1: "inspectDevice",
        title: "设备巡检列表"
      },
      component: InspectionDeviceList
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js